import type { ComponentProps } from 'react';

import {
  Tabs as ShadcnTabs,
  TabsContent as ShadcnTabsContent,
  TabsList as ShadcnTabsList,
  TabsTrigger as ShadcnTabsTrigger,
} from '@/components/shadcn/ui/tabs';
import { cn } from '@/lib/cn';

export function Tabs({
  className,
  ...props
}: ComponentProps<typeof ShadcnTabs>) {
  return <ShadcnTabs className={className} {...props} />;
}

export function TabsList({
  className,
  ...props
}: ComponentProps<typeof ShadcnTabsList>) {
  return (
    <ShadcnTabsList
      className={cn(
        'min-h-10 rounded-md border border-muted bg-secondary p-1',
        className,
      )}
      {...props}
    />
  );
}

export function TabsTrigger({
  className,
  ...props
}: ComponentProps<typeof ShadcnTabsTrigger>) {
  return (
    <ShadcnTabsTrigger
      className={cn('h-full w-full flex-1 px-3 py-1.5 rounded-1.5', className)}
      {...props}
    />
  );
}

export function TabsContent(props: ComponentProps<typeof ShadcnTabsContent>) {
  return <ShadcnTabsContent {...props} />;
}
